<template>
  <v-container id="recover" class="fill-height justify-center" tag="section">
    <v-row justify="center">
      <v-col lg="11" sm="8" xl="7">
        <v-card class="elevation-4">
          <v-row>
            <v-col lg="7" class="info d-none d-md-flex align-center justify-center">
              <div class="d-none d-sm-block">
                <div class="d-flex align-center pa-10">
                  <div>
                    <h2 class="display-1 white--text font-weight-medium">
                      {{ $t('pages.login.aside.title', { companyName: $options.COMPANY_NAME }) }}
                    </h2>

                    <h6 class="subtitle-1 mt-4 white--text op-5 font-weight-regular">
                      {{ $t('pages.login.aside.message') }}
                    </h6>
                  </div>
                </div>
              </div>
            </v-col>

            <v-col lg="5">
              <div class="pa-7 pa-sm-12">
                <v-alert v-if="error" dense type="error">
                  {{ error }}
                </v-alert>

                <v-alert v-if="isSent" dense type="info">
                  {{ $t('pages.recover.message.sent') }}
                </v-alert>

                <img :src="$options.LOGO_URL" :alt="$options.COMPANY_NAME" />

                <h2 class="font-weight-bold mt-4 blue-grey--text text--darken-2">
                  {{ $t('pages.recover.title') }}
                </h2>

                <h6 class="subtitle-1">
                  <router-link to="/login">{{ $t('pages.recover.login') }}</router-link>
                </h6>

                <v-form ref="form" v-model="isValid" lazy-validation @submit.prevent="onSubmit">
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    :label="$t('pages.recover.form.email')"
                    class="mt-4"
                    required
                    outlined
                  />

                  <v-btn :disabled="!isValid" color="info" block class="mr-4" type="submit">
                    {{ $t('pages.recover.action') }}
                  </v-btn>
                </v-form>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapActions, mapState } from 'vuex';

  import { buildSpecConfig } from 'src/config';

  export default {
    name: 'Login',

    data() {
      return {
        error: null,
        isValid: true,
        email: null,
        isSent: false,
      };
    },

    COMPANY_NAME: buildSpecConfig.companyName,
    LOGO_URL: buildSpecConfig.logoUrl,

    computed: {
      ...mapState('settings', ['hasLDAP']),

      emailRules() {
        return [v => !!v || this.$t('validation.emailEmpty')];
      },
    },

    created() {
      if (this.hasLDAP) {
        this.$router.push({ name: 'login' });
      }
    },

    methods: {
      ...mapActions('users', ['sendRecoveryCode']),

      validate() {
        this.isValid = this.$refs.form.validate();
      },

      async onSubmit() {
        this.validate();

        if (this.isBusy) {
          return;
        }

        this.isBusy = true;

        try {
          const backUrl = window.location.href.replace('/recover', '/accept/recover/:code');

          await this.sendRecoveryCode({ backUrl, email: this.email });
          this.isSent = true;
        } catch (err) {
          console.error('>>>>', err);
          this.error = this.$te(`serverCode.${err.code}`)
            ? this.$t(`serverCode.${err.code}`)
            : this.$t('serverCode.serverError');
        } finally {
          this.isBusy = false;
        }
      },
    },
  };
</script>
